<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml">
  <div style="" ref="sku_detail_page">
    <van-sticky>
      <div
          :style="{
          width: '100%',
          height: 'env(safe-area-inset-top)',
          backgroundColor: '#FFFFFF',
          marginBottom: '-2px',
        }"
      ></div>
      <Wp_nav_bar
          title="商品详情"
          :hasClick="true"
          @click="closeDetail"
      ></Wp_nav_bar>
    </van-sticky>

    <!--            计数器-->
    <Wp_access_count page-tag="sku_detail"></Wp_access_count>
    <div v-if="skuInfo">
      <Wp_img_swipe
          v-if="img_list && img_list.length > 0"
          :list="img_list"
          :height="screenWidth + 'px'"
          :video-list="video_list"
          @changeImg="getImageIndex"
      ></Wp_img_swipe>

      <!--        <van-button @click="test">测试</van-button>-->
      <div
          class="sku_title"
          style="padding: 12px 10px 0px 10px; font-size: 14px"
      >
        <h3>
          <span>
            <van-tag
                type="danger"
                style="font-size: 14px; padding: 0px 6px"
                v-if="skuInfo.owner === 'g'"
            >京东自营</van-tag
            >
            <van-tag
                type="danger"
                style="font-size: 14px; padding: 0px 6px"
                v-else
            >京东</van-tag
            >
          </span>
          <span
              v-clipboard:copy="skuInfo.skuName"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
          >{{ skuInfo.skuName }}</span
          >
        </h3>
      </div>

      <div
          style="text-align: right; padding: 10px 10px 0px 10px; color: #666666"
      >
        <span
            v-if="
            couponData &&
            couponData.discount &&
            skuInfo.priceInfo.lowestCouponPrice
          "
            style="margin-right: 15px"
        >
          京东价<span style="text-decoration: line-through">
            ¥ {{ skuInfo.priceInfo.lowestPrice }}</span
        >
        </span>
        <span style="margin-right: 15px"> 评论数 {{ skuInfo.comments }} </span>
        <span style="margin-right: 15px">
          好评率 {{ skuInfo.goodCommentsShare }}%
        </span>
        <span style="" @click="clickToBuy"> 查看详情> </span>
      </div>

      <div
          class="sku_tags"
          style="display: inline-block; margin-top: 5px; padding-left: 10px"
      >
        <div
            style="float: left; margin: 2px"
            v-if="
            couponData &&
            couponData.discount &&
            skuInfo.priceInfo.lowestCouponPrice
          "
        >
          <JdCouponBar :couponData="couponData" size="medium"></JdCouponBar>
        </div>

        <span
            v-if="skuInfo.pinGouInfo.pingouPrice"
            style="float: left; color: red; margin: 2px 5px"
        >
          <Icon type="ios-contacts" size="20"/>
          {{ skuInfo.pinGouInfo.pingouTmCount }}人拼
        </span>

        <div style="float: left; margin: 2px" v-if="skuInfo.isHot === 1">
          <van-tag color="red" plain size="medium">爆品</van-tag>
        </div>
        <div style="float: left; margin: 2px" v-if="giftData">
          <JdGiftBar :gift-data="giftData" size="xl"/>
        </div>

        <div
            v-if="robotList && robotList.length > 0"
            style="position: absolute; margin-top: 2px; right: 12px"
        >
          <Wp_join_robot_status_tag_model
              :is-pushed="is_pushed"
          ></Wp_join_robot_status_tag_model>
        </div>
      </div>

      <div
          style="padding-left: 15px; color: #999999"
          v-if="
          couponData &&
          couponData.discount &&
          skuInfo.priceInfo.lowestCouponPrice
        "
      >
        优惠券说明: 满{{ couponData.quota }}元可用&nbsp;&nbsp;{{
          coupon_start_time
        }}-{{ coupon_end_time }}
      </div>

      <div style="color: red; padding: 2px 15px">
        <span
            v-if="
            couponData &&
            couponData.discount &&
            skuInfo.priceInfo.lowestCouponPrice
          "
        >
          <span style="font-size: 13px">
            券后价 ¥
            <span style="font-size: 20px">{{
                (skuInfo.priceInfo.lowestCouponPrice - giftPrice).toFixed(2)
              }}</span>
          </span>
        </span>
        <span v-else style="font-size: 13px">
          京东价 ¥
          <span style="font-size: 20px">{{
              skuInfo.priceInfo.lowestPrice
            }}</span>
        </span>

        <span
            v-if="
            (!$common.gloabl_wx_openid ||
              $common.gloabl_wx_mini_login_status === 'super') &&
            $common.showSkuCommission()
          "
            style="float: right; padding-top: 3px"
        >
          预估佣金 ¥ <span style="font-size: 15px">{{ commission }}</span>
        </span>
      </div>
      <div
          style="
          text-align: right;
          padding-right: 10px;
          color: #999999;
          font-size: 13px;
        "
          v-clipboard:copy="skuInfo.skuId.toString()"
          v-clipboard:success="copySuccess"
          v-clipboard:error="copyError"
      >
        商品编号: {{ skuInfo.skuId }}
      </div>
      <van-divider style="padding: 0px; margin: 0px"></van-divider>

      <div
          v-if="
          is_coupon_can_use &&
          robotList &&
          robotList.length > 0 &&
          (!$common.gloabl_wx_openid ||
            $common.gloabl_wx_mini_login_status === 'super') &&
          !$common.isClient_whole()
        "
          style="padding: 10px"
      >
        <van-row style="text-align: center; padding: 5px 0px">
          <van-col span="8">
            <Wp_join_robot_button_model
                :sku-info="skuInfo"
                :link-content="linkContent"
                :robot-list="robotList"
                :img-list="img_list"
                width="90%"
                :coupon-data="couponData"
                @getPushStatus="getPushStatus"
                @getAllRobatSkuData="getAllRobatSkuData"
                @updataBadegSync="updataBadegSync"
            ></Wp_join_robot_button_model>
          </van-col>
          <van-col span="8">
            <van-button
                size="small"
                type="danger"
                style="
                width: 90%;
                background-color: orange;
                border: 1px solid orange;
                color: white;
              "
                v-clipboard:copy="linkContent.replace(new RegExp('<br/>','gm'), '\n')"
                v-clipboard:success="onCopySuccess"
                v-clipboard:error="onError"
            >
              复制文案
            </van-button>
          </van-col>
          <van-col span="8">
            <van-button
                size="small"
                type="info"
                style="width: 90%"
                @click="shareImg"
            >分享图片
            </van-button
            >
          </van-col>
        </van-row>
        <span style="font-size: 15px">商品文案:</span>
        <van-field
            v-model="linkContent"
            type="textarea"
            readonly
            :autosize="{ maxHeight: 300, minHeight: 100 }"
            style="
            border: 1px solid #77ffcc55;
            border-radius: 4px;
            padding: 10px;
            background-color: #77ffcc22;
          "
        ></van-field>
      </div>

      <van-divider style="padding: 0px; margin: 0px"></van-divider>

      <van-row style="text-align: center">
        <van-col span="8">
          <div style="text-align: center">
            <van-button
                icon="passed"
                size="mini"
                style="
                font-size: 11px;
                color: #666666;
                background-color: rgba(0, 0, 0, 0);
                border: 0px;
              "
            >京东商品
            </van-button
            >
          </div>
        </van-col>
        <van-col span="8">
          <div style="text-align: center">
            <van-button
                icon="passed"
                size="mini"
                style="
                font-size: 11px;
                color: #666666;
                background-color: rgba(0, 0, 0, 0);
                border: 0px;
              "
            >品质保证
            </van-button
            >
          </div>
        </van-col>
        <van-col span="8">
          <div style="text-align: center">
            <van-button
                icon="passed"
                size="mini"
                style="
                font-size: 11px;
                color: #666666;
                background-color: rgba(0, 0, 0, 0);
                border: 0px;
              "
            >无忧售后
            </van-button
            >
          </div>
        </van-col>
      </van-row>
      <div class="detailStyle" v-html="baseBigFieldInfo.wdis"></div>

    </div>
    <!--                <div class="bottom_button" :container="container" :style="{bottom: bottom_px}">-->
    <div>
      <div style="height: 70px; "></div>
      <div class="bottom_button" :style="{ bottom: bottom_px, paddingBottom: padding_bottom_px }">
        <van-row>
          <van-col span="4">
            <div @click="clickToHome">
              <div style="text-align: center; margin-top: 5px">
                <van-button
                    icon="home-o"
                    size="mini"
                    style="
                      font-size: 16px;
                      color: #777777;
                      background-color: rgba(0, 0, 0, 0);
                      border: 0px;
                    "
                ></van-button>
              </div>
              <div style="text-align: center; color: #777777">首页</div>
            </div>
          </van-col>
          <van-col span="10">
            <van-button
                size="large"
                style="
                  background-color: orange;
                  border: 1px solid orange;
                  border-radius: 0px;
                  color: white;
                "
                :disabled="!is_coupon_can_use"
                @click="clickToShare"
            >分享海报
            </van-button>
          </van-col>
          <van-col span="10">
            <van-button
                size="large"
                type="danger"
                style="border-radius: 0px"
                :disabled="!is_coupon_can_use"
                @click="clickToBuy"
            >立即购买
            </van-button
            >
          </van-col>
        </van-row>
      </div>
    </div>
    <div
        :style="{
          width: '100%',
          height: 'env(safe-area-inset-bottom)',
          backgroundColor: '#FFFFFF',
          position: 'fixed',
          top: '0px',
        }"
    ></div>
    <Wp_jd_skuinfo_poster
        ref="Wp_jd_skuinfo_poster"
        :sku-info="skuInfo"
        :gift-data="giftData"
        :coupon-data="couponData"
        :poster-img="posterImg"
    ></Wp_jd_skuinfo_poster>
  </div>
</template>

<script>
// import Vue from 'vue';

import Wp_nav_bar from '../custom/Wp_nav_bar'
import Wp_img_swipe from '../custom/Wp_img_swipe'
import Wp_jd_skuinfo_poster from '../custom/Wp_jd_skuinfo_poster'

import { ImagePreview, Toast } from 'vant'
import JdCouponBar from '../custom/JdCouponBar'
import Wp_join_robot_button_model from '../custom/Wp_join_robot_button_model'
import Wp_join_robot_status_tag_model from '../custom/Wp_join_robot_status_tag_model'
import Wp_access_count from '../custom/Wp_access_count'
import JdGiftBar from '../custom/JdGiftBar'
import union_utils from '../../js/union_utils'
// Vue.use(Toast);
// Vue.use(ImagePreview);

export default {
  name: 'Wp_jd_sku_detail_page',
  components: {
    JdGiftBar,
    Wp_access_count,
    Wp_join_robot_status_tag_model,
    Wp_join_robot_button_model,
    JdCouponBar,
    Wp_jd_skuinfo_poster,
    Wp_img_swipe,
    Wp_nav_bar,
  },

  props: {
    type: { type: String, default: 'page' }, //popup,page
    datas: { type: Object, default: null },
    skuIdString: { type: String, default: '' },
    giftData: { type: Object, default: null },
  },
  data () {
    return {
      skuInfo: null,
      img_list: [], //[{"img": "img_url", ...},{}]
      // 屏幕宽
      screenWidth:
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth,
      couponData: {},
      select_img_index: 0,
      posterImg: '',
      bottom_px: '0px',
      newLink: '',
      linkContent: '',
      //佣金金额
      commission: 0,
      //佣金比例
      commissionShare: 0,
      // //助理（机器人）列表
      robotList: [],
      // test_channel_name: "V006",
      channel_name: this.$store.state.username,
      //
      // //点击加入助理时弹出的内容展示
      // show_dialog_for_robot: false,
      // currentIndex: 0,
      // //是否可以加入助理
      // join_robot_status: true,

      //是否已推送
      is_pushed: false,
      is_coupon_can_use: true,
      video_list: [],
      coupon_start_time: '',
      coupon_end_time: '',
      detailImages: [],
      baseBigFieldInfo: {},
      padding_bottom_px: '0px',
      giftPrice: 0,
      giftText: '',
      toast: {},
    }
  },

  watch: {
    datas: {
      handler () {
        this.initSkuInfo()
      },
      deep: true,
    },
    skuIdString () {
      this.$log('-------------skuIdString------------')
      this.initSkuInfo()
    },
    skuInfo: {
      handler (nV, oV) {
        this.loadGiftInfo()
      },
      immediate: true,
      deep: true
    },
    giftData: {
      handler (nV, oV) {
        if (this.giftData && this.giftData.denomination) {
          this.giftPrice = this.giftData.denomination
          this.giftText = '+礼金' + this.giftPrice + '元'
        }
      },
      immediate: true,
      deep: true
    }
  },

  created () {
    this.initSkuInfo()
    this.getRobotList()
  },

  beforeDestroy () {
    if (this.toast) {
      this.toast.clear()
    }
  },

  mounted () {
    this.container = this.$refs.container
    this.set_bottom_space()
  },

  methods: {
    /**
     * 设置底部是否留白
     */
    set_bottom_space () {
      if (this.$common.is_weixn()) {
        let height1 = this.$common.screenHeight//屏幕高度，包含底部导航
        let height2 = document.documentElement.clientHeight
        if (height1 === height2) {
          // return true;
          this.padding_bottom_px = '30px'
        } else {
          // return false;
          this.padding_bottom_px = '0px'
        }
      } else {
        this.padding_bottom_px = '0px'
      }

    },
    initSkuInfo () {
      //两种方式展示详情，datas为通过props传递过来的数据，用户popup类型，$common.static_skuInfo为通过router打开新页面

      let skuId = this.$common.getUrlKey('skuId')

      if (skuId) {
        this.bottom_px = '50px'
        let params = {
          app_key: this.$common.getAppKeyInfo('70637').app_key,
          app_secret: this.$common.getAppKeyInfo('70637').app_secret,
          skuIds: [Number(skuId)],
        }

        this.$getSelectGoods(params, (response) => {
          if (response && response.code === 200) {
            if (response.data && response.data.length > 0) {
              this.skuInfo = response.data[0]

              if (this.skuInfo) {
                for (
                    let i = 0;
                    i < this.skuInfo.imageInfo.imageList.length;
                    i++
                ) {
                  this.img_list.push({
                    img: this.skuInfo.imageInfo.imageList[i].url,
                  })
                }

                // this.getPushStatus(this.skuInfo.skuId);

                this.findCoupon()
                this.initCommission()
                this.makeLinks()
              }
            }
          }
        })
      } else {
        if (this.datas) {
          this.skuInfo = this.datas
        } else if (this.$common.static_skuInfo) {
          this.skuInfo = this.$common.static_skuInfo
        }

        if (this.skuInfo) {
          for (let i = 0; i < this.skuInfo.imageInfo.imageList.length; i++) {
            this.img_list.push({
              img: this.skuInfo.imageInfo.imageList[i].url,
            })
          }

          // this.getPushStatus(this.skuInfo.skuId);

          if (this.skuInfo.skuId) {
            let params = {
              skuIds: [this.skuInfo.skuId]
            }
            this.$getSkuBigInfo(params, res => {
              if (res.code === 200 && res.data[0]) {
                let _data = res.data[0]
                let images = _data.detailImages
                if (images) {
                  this.detailImages = images.split(',')
                }
                this.baseBigFieldInfo = _data.baseBigFieldInfo
              }
            })
          }

          this.findCoupon()
          this.initCommission()
          this.makeLinks()
        }
      }

      //获取视频数据
      if (
          this.skuInfo &&
          this.skuInfo.videoInfo &&
          this.skuInfo.videoInfo.videoList
      ) {
        this.video_list = this.skuInfo.videoInfo.videoList
      }
    },

    copySkuName () {
      if (this.skuInfo) {
        this.copyToClipboard(this.skuInfo.skuName)
      } else {
        this.toast = Toast({
          message: '商品信息异常，复制失败',
        })
      }
    },

    copySkuId () {
      if (this.skuInfo) {
        this.copyToClipboard(this.skuInfo.skuId + '')
      } else {
        this.toast = Toast.fail({
          message: '商品信息异常，复制失败',
        })
      }
    },

    copyToClipboard (text) {
      if (text) {
        window.navigator.clipboard
            .writeText(text)
            .then(() => {
              window.navigator.clipboard.readText().then((clipText) => {
                if (clipText === text) {
                  this.copySuccess()
                } else {
                  this.copyError()
                }
              })
            })
            // eslint-disable-next-line no-unused-vars
            .catch((err) => {
              this.copyError()
            })
      }
    },

    copySuccess () {
      this.toast = Toast.success({
        message: '复制成功',
      })
    },
    copyError () {
      this.toast = Toast.fail({
        message: '复制失败',
      })
    },

    getImageIndex (index) {
      this.select_img_index = index
      if (this.skuInfo) {
        this.posterImg = this.skuInfo.imageInfo.imageList[index].url
      }
    },

    clickToHome () {
      this.closeDetail()
    },

    closeDetail () {
      this.clearDatas()
      if (this.type === 'popup') {
        this.$log('---------------close----------------')
        this.$emit('clickToCloseDetail')
      } else if (this.type === 'page') {
        this.$router.back()
      }
    },

    clearDatas () {
      this.skuInfo = null
      this.img_list = []
      this.couponData = {}
      this.newLink = ''
    },

    clickToShare () {
      if (this.$common.getPid()) {
        this.$refs.Wp_jd_skuinfo_poster.showSharePop()
      } else {
        // this.$dialog.alert({
        //     message: "缺少渠道id，操作中断"
        // })
        this.toast = Toast.fail({
          message: '缺少渠道id\n操作中断',
        })
      }
    },

    clickToBuy () {
      if (this.$common.getPid()) {
        if (this.newLink) {
          if (this.$common.isClient_hm() || this.$config.project === 'hm') {
            //如果是河马，则跳转小程序页面
            this.navigateToJd(this.newLink)
          } else {
            this.$union_utils.jumpUrl(this.newLink)
          }
        } else {
          this.makeLinks((shortURL) => {
            this.newLink = shortURL
            if (this.$common.isClient_hm()) {
              //如果是河马，则跳转小程序页面
              this.navigateToJd(this.newLink)
            } else {
              this.$union_utils.jumpUrl(this.newLink)
            }
          })
        }
      } else {
        // this.$dialog.alert({
        //     message: "缺少渠道id，操作中断"
        // })
        this.toast = Toast.fail({
          message: '缺少渠道id\n操作中断',
        })
      }
    },

    /**
     * 小程序详情页面点击购买，打开京东小程序(hm使用)
     */
    navigateToJd (jd_url) {
      this.$common.navigateToMiniProgramPage('/pages/jd/jd?', 'jd', jd_url)
    },

    getUrlParams (skuId) {
      let mediaId = this.$common.mediaId_70637
      let _materialId = 'https://wqitem.jd.com/item/view?sku=' + skuId
      let _couponUrl = ''
      if (
          this.couponData &&
          this.couponData.discount &&
          typeof this.couponData.discount !== 'undefined' &&
          this.skuInfo.priceInfo.lowestCouponPrice
      ) {
        _couponUrl = this.couponData.link
      }

      let _positionId = this.$common.getPid()
      //
      // if (this.position_id || this.$common.gloabl_wx_openid) {
      //     _positionId = this.position_id;
      // }

      // let _positionId = '1825325610';

      let _data = {
        app_key: this.$common.getAppKeyInfo(mediaId).app_key,
        app_secret: this.$common.getAppKeyInfo(mediaId).app_secret,
        materialId: _materialId,
        subUnionId: '',
        positionId: _positionId, //推广位ID
        // pid: _pid,
        couponUrl: _couponUrl,
        chainType: 2,
      }

      //添加礼金代码
      if (this.giftData && this.giftData.giftCouponKey) {
        _data['giftCouponKey'] = this.giftData.giftCouponKey
      }

      return _data
    },

    /**
     * 查找优惠券
     */
    findCoupon () {
      let couponList = this.skuInfo.couponInfo.couponList
      let _couponData = this.$common.autoFindCoupon2(couponList)
      if (_couponData) {
        this.couponData = _couponData
        // this.coupon_start_time = this.$common.dateFmt('yyyy-MM-dd hh:mm:ss', new Date(_couponData.getStartTime));
        // this.coupon_end_time = this.$common.dateFmt('yyyy-MM-dd hh:mm:ss', new Date(_couponData.getEndTime));
        this.coupon_start_time = this.$common.dateFmt(
            'yyyy.MM.dd',
            new Date(_couponData.useStartTime)
        )
        this.coupon_end_time = this.$common.dateFmt(
            'yyyy.MM.dd',
            new Date(_couponData.useEndTime)
        )
      }
    },

    initCommission () {
      if (this.skuInfo) {
        //佣金比例，除以2，平分，0.9是订单返回数据中的finalRate最终比例
        this.commissionShare =
            this.skuInfo.commissionInfo.commissionShare *
            0.9 *
            this.$common.commissionRate_pir
        if (this.commissionShare.toString().indexOf('.') > 0) {
          this.commissionShare = this.commissionShare.toFixed(2)
        }

        if (
            this.couponData &&
            this.couponData.discount &&
            this.skuInfo.priceInfo.lowestCouponPrice
        ) {
          //如果包含优惠券，佣金金额=(最低金额-优惠券金额) * 佣金比例 / 2 / 100，取小数点后两位，（除以2是平分实际佣金）
          this.commission =
              this.skuInfo.priceInfo.lowestCouponPrice *
              (this.commissionShare / 100)
        } else {
          // this.commission = (this.skuInfo.commissionInfo.commission / 2);
          this.commission =
              this.skuInfo.priceInfo.lowestPrice * (this.commissionShare / 100)
        }
        //取两位小数
        this.commission = this.commission.toFixed(2)
      }
    },

    makeLinks (fn) {
      let _skuId = this.skuInfo.skuId
      if (_skuId) {
        let _data = this.getUrlParams(_skuId)

        this.$getUnionLink(_data, (response) => {
          let code = response.code
          // let message = response.message;
          if (code === 200) {
            this.is_coupon_can_use = true
            let shortURL = response.data.shortURL
            this.newLink = shortURL
            if (fn && typeof fn === 'function') {
              fn(shortURL)
            } else {
              this.getLinkContent(shortURL)
            }
          } else {
            this.is_coupon_can_use = false
            // Dialog.alert({
            //     message: "添加失败，商品活动已过期"
            // });
            let _message = '数据获取失败或商品活动已过期'
            if (response.message) {
              _message = response.message
            }
            this.toast = Toast({
              duration: 20000,
              message: _message,
            })
          }
          // else if (code === 2001917) {
          //     this.is_coupon_can_use = false;
          //     Dialog.alert({
          //         message: response.message
          //     });
          // }
          // else if(code === 2001905){
          //     //优惠券有效状态不可用
          //     this.is_coupon_can_use = false;
          //     Dialog.alert({
          //         message: "优惠券已失效"
          //     });
          // }else if(code === 2001911){
          //     //商品价格小于优惠券价格限制
          //     this.is_coupon_can_use = false;
          //     Dialog.alert({
          //         message: response.message
          //     });
          // }
        })
      }
    },

    getLinkContent (newLink) {
      // 评论数: 3W+
      // 好评率: 99%
      // 京东价: 209元
      // 优惠券: 30元
      // 内购价: 179元
      // 返利: 0.9元
      // 推广佣金: 1.2元
      // 入口: https://u.jd.com/9EcGZ6
      let content = ''
      // content += '【' + this.skuInfo.brandName + '】' + this.skuInfo.skuName + '\n';
      if (this.skuInfo.documentInfo && this.skuInfo.documentInfo.document) {
        content += '【京东】' + this.skuInfo.documentInfo.document + '\n'
      } else {
        content += '【京东】' + this.skuInfo.skuName + '\n'
      }
      content += '评论数: ' + this.skuInfo.comments + '  '
      content += '好评率: ' + this.skuInfo.goodCommentsShare + '%' + '\n'
      content += '--------------------------' + '\n'

      if (
          this.couponData &&
          this.couponData.discount &&
          typeof this.couponData.discount !== 'undefined' &&
          this.skuInfo.priceInfo.lowestCouponPrice
      ) {

        content +=
            '京东价: ' +
            this.skuInfo.priceInfo.lowestPrice.toFixed(2) +
            '元(券' +
            this.couponData.discount.toFixed(0) +
            '元' + this.giftText + ')' +
            '\n'
        // content += '优惠券: ' + (this.couponData.discount).toFixed(2) + '元' + '\n';

        content +=
            '到手价: ' +
            (this.skuInfo.priceInfo.lowestCouponPrice.toFixed(2) - this.giftPrice) +
            '元' +
            '\n'
      } else {
        content +=
            '京东价: ' +
            this.skuInfo.priceInfo.lowestPrice.toFixed(2) +
            '元' +
            '\n'
      }
      content += '抢购: ' + newLink + '\n'
      content += '--------------------------' + '\n'
      let second_host_url = this.$store.state.username + '.wapg.cn'
      content += '更多优惠: ' + second_host_url.toLowerCase()
      this.linkContent = content
    },

    onCopySuccess () {
      this.toast = Toast.success({
        message: '文案复制成功',
      })
    },

    onError () {
      this.toast = Toast.fail({
        message: '文案复制失败，请尝试手动复制文案',
      })
    },

    getRobotList () {
      this.$getRobotList((list) => {
        this.robotList = list
      })
      // let params = {
      //     // channel_name: this.test_channel_name,
      //     channel_name: this.channel_name,
      // };
      //
      // this.$getRobotByChannelname(params, response=>{
      //     if(response && response.code == 200){
      //         this.robotList = response.data.list;
      //     }
      // })
    },

    /**
     * 更新角标（来自Wp_join_robot_button_model）
     */
    updataBadegSync (addOne) {
      this.$emit('updataBadegSync', addOne)
    },

    settest (_refresh) {
    },

    /**
     * 获取全部数据（来自Wp_join_robot_button_model）
     */
    getAllRobatSkuData (data) {
      this.$emit('getAllRobatSkuData', data)
    },

    getPushStatus (push_status) {
      this.is_pushed = push_status
    },

    shareImg () {
      if (this.img_list && this.img_list.length > 0) {
        ImagePreview({
          images: this.getImages(this.img_list),
          startPosition: this.select_img_index,
        })
      } else {
        this.toast = Toast.fail({
          message: '无图片数据',
        })
      }
    },
    getImages (_images) {
      let imgs = []
      for (let i = 0; i < _images.length; i++) {
        imgs.push(_images[i].img)
      }
      return imgs
    },

    //根据skuId读取礼金信息，不是所有商品都有礼金
    loadGiftInfo () {
      if (this.skuInfo && this.skuInfo.skuId) {
        let data = {
          skuId: this.skuInfo.skuId
        }
        this.$getGiftInfo(data, res => {
          if (res.code === 200) {

            if (res.data && res.data.length > 0) {
              this.giftData = res.data[0]
            }
          }
        })
      }
    }
  },
}
</script>

<style scoped>
.sku_title {
  /*height: 45px;*/
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.bottom_button {
  padding-top: 1px;
  /*padding-bottom: 50px;*/
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: white;
  box-shadow: 1px -1px 3px #888888;
}

.imgStyle {
  float: left;
}

/deep/ .detailStyle img {
  float: left;
}

</style>